import SingleChoiceQuestionTask from 'models/task/question/questionTask/choice/SingleChoiceQuestionTask';

/**
 * Class representing a text single choice question task.
 * @extends SingleChoiceQuestionTask
 */
export default class TextSingleChoiceQuestionTask extends SingleChoiceQuestionTask {}
